import api from '@shared/api';

import {
    DictionarySearchResponse,
    JobTemplateDto,
    JobTemplateSearchPayload,
    JobTemplateSearchResponse,
    JobTemplateUpdatePayload,
} from './types';

const JOBS_PATH = 'dda/api/v1';
const NSI_PATH = 'dda-trs-nsi-api/api/v1';

export const fetchJobTemplates = async (payload: JobTemplateSearchPayload) =>
    (await api.post<JobTemplateSearchResponse>(`${JOBS_PATH}/job_info/search`, payload)).data;

export const fetchJobTemplate = async (id: string) =>
    (await api.get<JobTemplateDto>(`${JOBS_PATH}/job_info/${id}`)).data;

export const updateJobTemplate = async ({
    id,
    payload,
}: {
    id: string;
    payload: JobTemplateUpdatePayload;
}) => (await api.put<JobTemplateDto>(`${JOBS_PATH}/job_info/${id}`, payload)).data;

export const fetchActiveStatuses = async () =>
    (
        await api.post<DictionarySearchResponse>(`${NSI_PATH}/dict_active_status/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;
